export function parseCsv(text, delimiter = ';') {
  const lines = text.split(/\r?\n/).filter(Boolean);
  if (!lines.length) return [];

  const rawHeaders = lines[0].split(delimiter).map(h => h.trim());
  const headers = rawHeaders.map(h =>
    h === 'Id' ? 'id' : h.replace(/\s+/g, '_')
  );
  const rows = lines.slice(1);

  return rows.map(row => {
    const cells = row.split(delimiter);
    const obj = {};
    headers.forEach((key, idx) => {
      let value = (cells[idx] || '').trim();
      if (key === 'id') value = Number(value);
      obj[key] = value;
    });

    // Преобразуем поле duration: "30 мин" -> 30 (number)
    if (obj.duration) {
      const match = obj.duration.match(/(\d+)/);
      obj.duration = match ? Number(match[1]) : null;
    }

    return obj;
  });
} 